<template>
    <div>
        <b-container fluid class="review-table table-responsive" >
            <b-row>
                <b-col md="auto">
                    <font-awesome-icon 
                        @click="toggleCollapse" 
                        v-if="!visible" 
                        :icon="['fas', 'caret-down']"></font-awesome-icon>
                    <font-awesome-icon 
                        @click="toggleCollapse"
                        v-if="visible" 
                        :icon="['fas', 'caret-up']"></font-awesome-icon>
                </b-col>
                <b-col @click="toggleCollapse">
                    <h4>{{checklist.auditCode}} | <span>{{checklist.desc}}</span> </h4>
                </b-col>
                <!-- <b-col md="auto" v-if="isEditor">
                    <img @click=onEditListDesc(checklist) class="img-fluid edit-img" src="@/assets/img/edit.png">
                </b-col>
                <b-col md="auto" v-if="isEditor">
                    <img @click="$emit('deleteList', checklist)" class="img-fluid del-img" src="@/assets/img/delete.png">
                </b-col> -->
            </b-row>
        </b-container>
        <b-collapse
            :id="'collapse-'+checklist.id"
            v-model="visible">
            <div class="review-table" v-if="anyRows">
               <b-table
                    striped
                    hover
                    :items="questions"
                    :fields="checklistFields"
                    tdClass="text-left"
                    sort-by="auditCode"
                >
               </b-table>
            </div>
            <b-container v-for="item in checklist.lists" :key="item.id" fluid>
                <b-row>
                    <b-col>
                        <checklistTemplate
                            :checklist="item">
                        </checklistTemplate>
                    </b-col>
                </b-row>
            </b-container>
        </b-collapse>
    </div>

</template>

<script>
export default {
    name: 'ChecklistTemplate',
    data() {
        return {
            visible:false,
            checklistFields: [
                {
                    key: 'auditCode',
                    label: 'Audit Code',
                    sortable: true
                },
                {
                    key: 'desc',
                    label: 'Description',
                    sortable: false
                }
            ]

        }
    },
    props: [
        "checklist",
    ],
    computed: {
        anyRows() {
            return this.questions && this.questions.length > 0;
        },
        questions() {
            return this.checklist.questions
        }
    },
    methods: {
        toggleCollapse: function() {
            this.visible = !this.visible;
        }
    }
}
</script>